import { getHealthTerms } from "./../../services/HealthInformationService";

export const SET_HEALTH_TERMS = "SET_HEALTH_TERMS";

export function dispatchHealthTerms() {
  return dispatch =>
    getHealthTerms().then(response => {
      dispatch({
        type: SET_HEALTH_TERMS,
        payload: response.data
      });
    });
}
